
import React from "react";
import { ProductAttribute } from "@/types/attributes";
import { useThemeConfig } from "@/components/ui/theme-config-provider";

interface TagDisplayProps {
  attributes: ProductAttribute[];
  className?: string;
}

const TagDisplay: React.FC<TagDisplayProps> = ({ attributes, className = "" }) => {
  const { theme } = useThemeConfig();
  // Assicuriamoci che attributes sia un array
  const attributesArray = Array.isArray(attributes) ? attributes : [];
  
  if (!attributesArray.length) return null;

  return (
    <div className={`flex flex-wrap gap-1 ${className}`}>
      {attributesArray.map((attr) => (
        <span
          key={attr.id}
          className="px-1 py-px text-[10px] font-semibold rounded-sm select-none"
          style={{
            backgroundColor: theme.cardBackgroundColor,
            color: theme.textColor,
          }}
        >
          {attr.label}
        </span>
      ))}
    </div>
  );
};

export default TagDisplay;
